import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const COOKIE_KEY = 'ofertiz_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      // Pequeno delay para não aparecer antes da página carregar
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem(COOKIE_KEY, 'all');
    setVisible(false);
  };

  const handleEssentialOnly = () => {
    localStorage.setItem(COOKIE_KEY, 'essential');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-icon">
          <i className="fas fa-cookie-bite"></i>
        </div>
        <div className="cookie-consent-content">
          <h3 className="cookie-consent-title">Sua privacidade importa 🔒</h3>
          <p className="cookie-consent-text">
            Usamos <strong>cookies essenciais</strong> para o login e funcionamento, e cookies de análise para melhorar sua experiência.
            Ao clicar em "Aceitar todos", você concorda com nossa{' '}
            <Link to="/politica-de-privacidade" className="cookie-consent-link">
              Política de Privacidade
            </Link>
            .
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button className="cookie-btn cookie-btn-essential" onClick={handleEssentialOnly}>
            Somente essenciais
          </button>
          <button className="cookie-btn cookie-btn-accept" onClick={handleAcceptAll}>
            <i className="fas fa-check"></i> Aceitar todos
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
